import {sendMessage} from '../../api'

const userApiStore = {
  state: {
    message: ''
  },
  getters: {
    message: state => {
      return state.message
    },
    messageValid: state => {
      return state.message.length > 0
    },
    messageInputValid: (state, getters) => {
      return getters.messageValid
    }
  },
  mutations: {
    updateMessage (state, message) {
      state.message = message
    },
    clearMessage (state) {
      state.message = ''
    }
  },
  actions: {
    /**
     * Send updated account details
     */
    messageSend (context) {
      const apiClient = context.getters.apiClient
      const userId = context.getters.userId
      const emailAddress = context.getters.emailAddress
      const fullName = context.getters.fullName
      const serviceYear = context.getters.serviceYear
      const address = context.getters.address
      const selected = context.getters.services
      const notes = context.getters.notes
      const messageIncluded = context.getters.message !== undefined
      const message = (messageIncluded) ? context.getters.message : undefined

      return sendMessage(apiClient, userId, emailAddress, fullName, serviceYear, address, selected, notes, message)
        .then((result) => {
          if (messageIncluded) context.commit('clearMessage')
          console.log('Send message result: %j', result)
          return result
        })
        .catch((error) => {
          // TODO track the error message somewhere?
          throw error
        })
    }
  }
}

export default userApiStore



// WEBPACK FOOTER //
// ./src/store/app/message.js